<template>
  <v-row justify="center">
    <v-dialog :value="value" persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="headline">
          <slot name="title">
            {{ title }}
          </slot>
        </v-card-title>
        <v-card-text>
          <slot>
            {{ message }}
          </slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <slot name="refuse-btn">
            <v-btn color="secondary" @click="refuse">
              {{ btnRefuse }}
            </v-btn>
          </slot>
          <slot name="accept-btn">
            <v-btn color="primary" :loading="loading" @click="accept">
              {{ btnAccept }}
            </v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Eliminar registro'
    },
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '¿Desea eliminar este item?'
    },
    btnAccept: {
      type: String,
      default: 'Si'
    },
    btnRefuse: {
      type: String,
      default: 'No'
    },
    maxWidth: {
      type: Number,
      default: 290
    }
  },
  methods: {
    refuse() {
      this.$emit('refuse');
    },
    accept() {
      this.$emit('accept');
    }
  }
};
</script>
